import api from './index';
//
let exports = {};

exports.getShopDeviceSvcSubNoList = function (data, callback) {// 门店设备服务号列表（包含门店服务子号）
    api.post('/shop/devc/svc/sub/no/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.updateShopDeviceCatOrBrandInfo = function (data, callback) {// 修改门店设备-分类、品牌
    api.post('/shop/devc/cat/or/brand/set')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getShopDeviceSvcSubNo = function (data, callback) {// 门店设备服务号详情
    api.post('/shop/devc/svc/sub/no/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getShopDeviceBrandList = function (data, callback) {// 获取设备型号中的品牌列表
    api.post('/shop/devc/brand/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//门店设备分页列表
exports.getShopDeviceList = function (data, callback) {
    api.post('/shop/devc/pc/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//门店设备服务号列表
exports.getShopDeviceSvcNoList = function (data, callback) {
    api.post('/shop/devc/pc/svc/no/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//查询门店设备根据id-PC
exports.getShopDeviceById = function (data, callback) {
    api.post('/shop/devc/device/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 唯一键查询门店设备信息
exports.getShopDeviceByUk = function (data, callback) {
    api.post('/shop/devc/device/get/by/uk')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//save门店设备-PC
exports.updateShopDevice = function (data, callback) {
    api.post('/shop/devc/device/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.doClearSingleShopDeviceBatchStock = function (data, callback) {
    api.post('/shop/devc/batch/stock/cleared/set/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.doSetShopDeviceSvcSubNoCleared = function (data, callback) {
    api.post('/shop/devc/svc/sub/no/cleared/set/do')
    .data(data)
    .done(callback)
    .go();
};

// 子设备归还 - 生成归还单
exports.saveShopDeviceReturnVoucher = function (data, callback) {
    api.post('/shop/devc/return/voucher/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.saveShopDeviceReceiveVoucher = function (data, callback) {
    api.post('/shop/devc/receive/voucher/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 门店设备服务子号--停用
exports.doShopDeviceSvcSubNoOutage = function (data, callback) {
    api.post('/shop/devc/svc/sub/no/outage/do')
    .params(data)
    .done(callback)
    .go();
};

// 门店设备服务子号--修改设备的关键信息
exports.updateShopDeviceSvcSubNoKeyById = function (data, callback) {
    api.post('/shop/devc/svcSubNo/update/keyword/do')
    .data(data)
    .done(callback)
    .go();
};

//统计类
exports.getShopDeviceStatisList = function (data, callback) {
    api.post('/shop/devc/mTween/list/get/by/comId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//设备维修门店对比统计表
exports.getDeviceShopStatisList = function (data, callback) {
    api.post('/shop/devc/shop/mTween/list/get/by/comId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

//更改默认服务商
exports.updateDefServicer = function (data, callback) {
    api.post('/shop/devc/device/defServicer/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}
//批量更改默认服务商
exports.updateDefServicerBatch = function (data, callback) {
    api.post('/shop/devc/device/defServicer/batch/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

//门店设备服务号切换合同
exports.updateShopDeviceSvcNoByCurrContract = function (data, callback) {
    api.post('/shop/devc/device/svc/sub/no/curr/contract/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

//固定资产导入验证同源资产
exports.validateShopDeviceTitle = function (data, callback) {
    api.post('/shop/devc/imp/model/devc/name/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

//执行设备模型信息导入，返回导入记录Id
exports.doDeviceImpModelImport = function (data, callback) {
    api.post('/shop/devc/imp/model/import/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

// ============================== 设备保养计划 ==========================
exports.getDeviceMaintPlanList = function (data, callback) { // 获取设备保养计划列表
    api.post('/shop/devc/maint/plan/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveShopDeviceMaintProofRel = function (data, callback) { // （零售）门店设备（适用）维修保养凭单保存
    api.post('/shop/devc/maint/proof/rel/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.deleteShopDeviceMaintProofRel = function (data, callback) { // （零售）门店设备（适用）维修保养凭单保存
    api.post('/shop/devc/maint/proof/rel/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceMaintProofRelListBydevcSubNoId = function (params, callback) { // （零售）门店设备（适用）维修保养凭单保存
    api.get('/shop/devc/maint/proof/rel/get/list/by/devcSubNoId')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.exitShopDeviceMaintProofRelListBydevcMaintProofId = function (params, callback) { // （零售）门店设备（适用）维修保养凭单保存
    api.get('/shop/devc/maint/proof/rel/get/list/by/devcMaintProofId')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getDeviceMaintPlanNotTerminated = function (params, callback) { // 查询设备中是否有未执行为的保养计划
    api.post('/shop/devc/maint/plan/not/terminated/get/by/devcXIds')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
//设备明细-导出
exports.shopDeviceSubNoListForExport = function (data, callback) {
    api.post('/shop/devc/svc/sub/no/export/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备操作记录 - 分页
exports.getShopDeviceRecList = function (params, callback) {
    api.post('/shop/devc/act/rec/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备操作记录 - 不分页
exports.getShopDeviceRecNotPageList = function (params, callback) {
    api.post('/shop/devc/act/rec/not/page/list/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceRecPageList = function (params, callback) {
    api.post('/shop/devc/act/rec/list/page/get')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

// ----------------------- 批次库存 ---------------------

exports.getShopDeviceBatchStockList = function (data, callback) {   // 批次库存分页列表
    api.post('/shop/devc/batch/stock/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getSelectShopDeviceBatchStockList = function (data, callback) {   // 批次库存-通用选择
    api.post('/shop/devc/batch/stock/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ===================== 设备调拨 ================================
// 设备调拨列表
// exports.getShopDeviceTransVoucherList = function (data, callback) {
//     api.post('/shop/devc/trans/voucher/list/get')
//     .data(data)
//     .done(callback)
//     .fail(callback)
//     .go();
// };
// 根据id查询调拨单
// exports.getShopDeviceTransVoucherById = function (params, callback) {
//     api.post('/shop/devc/trans/voucher/get/by/id')
//     .data(params)
//     .done(callback)
//     .fail(callback)
//     .go();
// };
// 保存调拨单
// exports.saveShopDeviceTransVoucher = function (data, callback) {
//     api.post('/shop/devc/trans/voucher/save/do')
//     .data(data)
//     .done(callback)
//     .fail(callback)
//     .go();
// };
// 申请调拨单
// exports.applyShopDeviceTransVoucher = function (data, callback) {
//     api.post('/shop/devc/trans/voucher/apply/do')
//     .data(data)
//     .done(callback)
//     .fail(callback)
//     .go();
// };
// 审核调拨单
// exports.aduitShopDeviceTransVoucher = function (data, callback) {
//     api.post('/shop/devc/trans/voucher/aduit/do')
//     .data(data)
//     .done(callback)
//     .fail(callback)
//     .go();
// };
// 确认调拨单
// exports.confirmShopDeviceTransVoucher = function (data, callback) {
//     api.post('/shop/devc/trans/voucher/confirm/do')
//     .data(data)
//     .done(callback)
//     .fail(callback)
//     .go();
// };
// 删除调拨单
// exports.deleteShopDeviceTransVoucher = function (data, callback) {
//     api.post('/shop/devc/trans/voucher/delete/do')
//     .data(data)
//     .done(callback)
//     .fail(callback)
//     .go();
// };
// 作废调拨单
// exports.doInvalidTransVoucher = function (data, callback) {
//     api.post('/shop/devc/trans/voucher/invalid/do')
//     .data(data)
//     .done(callback)
//     .fail(callback)
//     .go();
// };
// 调拨单审核记录
// exports.getShopDeviceTransAuditRecByVoucherId = function (data, callback) {
//     api.get('/shop/devc/trans/voucher/audit/rec/get/voucherId')
//     .params(data)
//     .done(callback)
//     .fail(callback)
//     .go();
// };

// 调拨单查询
// exports.getShopDeviceTransVoucher = function (data, callback) {
//     api.get('/shop/devc/trans/voucher/get')
//     .params(data)
//     .done(callback)
//     .fail(callback)
//     .go();
// };

// 调拨单项查询
// exports.getShopDeviceTransVoucherItemList = function (data, callback) {
//     api.post('/shop/devc/trans/voucher/item/list/get')
//     .data(data)
//     .done(callback)
//     .fail(callback)
//     .go();
// };

// ============================ 耐耗品导出贴码 ==========================

// =================================== 设备出入库单 =========================

// 入库单-条目查询-不分页-带其他参数
exports.getShopDeviceIoItemList = function (data, callback) {
    api.post('/shop/devc/io/item/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

// 清理固定资产保存
exports.doClearShopDeviceIoVoucher = function (data, callback) {
    api.post('/shop/devc/io/voucher/clear/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}

// （零售）门店设备-公开报修记录-分页查询
exports.getDeviceOuterRepairRecList = function (data, callback) {
    api.post('/shop/devc/outer/repair/rec/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// （零售）门店设备-巡查记录-分页查询
exports.getDevicePatrolRecList = function (data, callback) {
    api.post('/shop/devc/patrol/rec/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取巡查记录-导出url
exports.getDevicePatrolRecListExportUrl = function (data, callback) {
    api.post('/shop/devc/patrol/rec/list/export/url/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取资产高级选项
exports.getAssetAdvancedOptions = function (data, callback) {
    api.post('/shop/devc/asset/advanced/options/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 查询资产数量
exports.getAssetCount = function (data, callback) {
    api.post('/shop/devc/asset/count/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单模版-分页列表
exports.getDevcInfoFormTplList = function (data, callback) {
    api.post('/shop/devc/info/form/tpl/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单模版-根据id查询
exports.getDevcInfoFormTpl = function (data, callback) {
    api.get('/shop/devc/info/form/tpl/get')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单模版-保存
exports.saveDevcInfoFormTpl = function (data, callback) {
    api.post('/shop/devc/info/form/tpl/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单模版-修改
exports.updateDevcInfoFormTpl = function (data, callback) {
    api.post('/shop/devc/info/form/tpl/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单模版-删除
exports.deleteDevcInfoFormTpl = function (data, callback) {
    api.post('/shop/devc/info/form/tpl/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单模版-上下移
exports.doDevcInfoFormTplMove = function (data, callback) {
    api.post('/shop/devc/info/form/tpl/move/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// =============================================设备信息单
// 设备信息单-分页列表
exports.getDevcInfoFormList = function (data, callback) {
    api.post('/shop/devc/info/form/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单-根据id查询
exports.getDevcInfoForm = function (data, callback) {
    api.get('/shop/devc/info/form/get')
    .params(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单-保存
exports.saveDevcInfoForm = function (data, callback) {
    api.post('/shop/devc/info/form/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单-修改
exports.updateDevcInfoForm = function (data, callback) {
    api.post('/shop/devc/info/form/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单-删除
exports.deleteDevcInfoForm = function (data, callback) {
    api.post('/shop/devc/info/form/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备信息单-上下移
exports.doDevcInfoFormMove = function (data, callback) {
    api.post('/shop/devc/info/form/move/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备型号 -- 保存服务商
exports.doSaveShopDeviceServicer = function (data, callback) {
    api.post('/shop/devc/servcer/save')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取单个资产编码
exports.getAssetInnerCodeByContext = function (data, callback) {
    api.post('/shop/devc/asset/innerCode/get/By/context')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 获取多个资产编码
exports.getBatchAssetInnerCodeByContext = function (data/*需要生成资产编码的数据集合*/, callback) {
    api.post('/shop/devc/batch/asset/innerCode/By/context')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备/资产更换定义
exports.doChangeAssetDevcDef = function (data, callback) {
    api.post('/shop/devc/asset/devcDef/change/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 计算资产拆分金额
exports.getCalAssetWorth = function (data, callback) {
    api.post('/shop/devc/asset/worth/cal/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 设备业务行为记录-分页列表
exports.getDevcBizBhvRecList = function (data, callback) {
    api.post('/shop/devc/biz/bhv/rec/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//提交设备业务行为记录数据，返回下载uuid
exports.getDevcBizBhvRecListDownloadUuid = function (data, callback) {
    api.post('/shop/devc/biz/bhv/rec/list/download/uuid/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getShopDeviceIdByDevcGroup = function (data, callback) {
    api.post('/shop/devc/deviceId/get/by/devcGroup')
    .data(data)
    .done(callback)
    .go();
};
exports.getLeasingDevcListByFilter = function (data, callback) {// 出租设备列表
    api.post('/shop/devc/leasing/devc/list/get/by/filter')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getLeasingDevcPaginatedList = function (data, callback) {// 用于-我的租用中设备分页列表
    api.post('/shop/devc/leasing/devc/paged/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getLeasingDevcList = function (data, callback) {// 用于-我的租用中设备列表
    api.post('/shop/devc/leasing/devc/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.saveLeasingDevc = function (data, callback) {// 设置可出租
    api.post('/shop/devc/leasing/devc/save')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.deleteLeasingDevc = function (data, callback) {// 移除可出租
    api.post('/shop/devc/leasing/devc/delete')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ============================ 自有资产分类 =============================
// 自有设备分类分页列表
exports.getDevcCatList = function (data, callback) {
    api.post('/shop/devc/cat/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 自有设备分类分页列表
exports.getDevcCatDetail = function (params, callback) {
    api.get('/shop/devc/cat/get/by/id')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

// 自有设备分类分页列表
exports.getDevcCatPageList = function (data, callback) {
    api.post('/shop/devc/cat/list/page/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 自有设备分类列表
exports.getDevcCatTreeList = function (data, callback) {
    api.post('/shop/devc/cat/tree/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 自有设备分类列表
exports.getDevcCatListByParentId = function (data, callback) {
    api.post('/shop/devc/cat/list/get/by/parentId')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 自有设备分类上下移动
exports.moveDevcCatSeq = function (data, callback) {
    api.post('/shop/devc/cat/seq/move/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 自有设备分类上下移动
exports.updateDevcCatGoodsCatById = function (data, callback) {
    api.post('/shop/devc/cat/update/goodsCatId/By/id')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 自有设备分类新增
exports.saveDevcCat = function (data, callback) {
    api.post('/shop/devc/cat/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 自有设备分类 - 申请
exports.applyDevcCatInfo = function (data, callback) {
    api.post('/shop/devc/cat/inner/apply/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 自有设备分类 - 审核
exports.aduitDevcCatInfo = function (data, callback) {
    api.post('/shop/devc/cat/inner/audit/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 自有设备分类修改
exports.updateDevcCat = function (data, callback) {
    api.post('/shop/devc/cat/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 自有设备分类删除
exports.deleteDevcCat = function (data, callback) {
    api.post('/shop/devc/cat/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 自有设备导入前检查
exports.validateDevcCatModel = function (data, callback) {
    api.post('/shop/devc/cat/imp/model/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 自有设备分类导入，返回导入成功数量
exports.doDevcCatImpModelImport = function (data, callback) {
    api.post('/shop/devc/cat/imp/model/import/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 自有设备分类导入，返回导入成功数量
exports.getDevcCatById = function (params, callback) {
    api.get('/shop/devc/cat/get/by/id')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 自有设备分类禁用
exports.updateDevcCatDisabledById = function (data, callback) {
    api.post('/shop/devc/cat/update/disabled/By/id')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 资产分类-获取资产分类内部审核列表
exports.getDevcCatAuditRecList = function (data, callback) {
    api.post('/shop/devc/cat/audit/rec/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//
exports.getDevcGoodsCatRelPageList = function (data, callback) {
    api.post('/shop/devc/goods/cat/rel/page/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.getDevcGoodsCatRelList = function (data, callback) {
    api.post('/shop/devc/goods/cat/rel/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.deleteDevcGoodsCatRelById = function (data, callback) {
    api.post('/shop/devc/goods/cat/rel/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 自有设备分类导入
exports.doImportDevcCat = function (data, callback) {
    api.post('/shop/devc/cat/import/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 自有设备分类导入
exports.doCheckDevcCat = function (data, callback) {
    api.post('/shop/devc/cat/check/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
}
// 自有设备分类导入
exports.doApplyDevcCat = function (data, callback) {
    api.post('/shop/devc/cat/apply/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 批量申请自有资产分类
exports.doApplyDevcCatBatch = function (data, callback) {
    api.post('/shop/devc/cat/batch/apply/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 查询自有分类的申请列表
exports.getDevcCatApplyRecList = function (data, callback) {
    api.post('/shop/devc/cat/apply/rec/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ===================== 自有资产品牌 ===========================

exports.getDevcBrandList = function (data, callback) {
    api.post('/shop/devc/brand/get/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

exports.getDevcBrandListByFilter = function (data, callback) {
    api.post('/shop/devc/brand/get/list/by/filter')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

//获取自有资产品牌
exports.getDevcBrandById = function (params, callback) {
    api.get('/shop/devc/brand/get/by/id')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};

//保存自有资产品牌
exports.saveDevcBrand = function (data, callback) {
    api.post('/shop/devc/brand/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//删除自有资产品牌
exports.deleteDevcBrand = function (data, callback) {
    api.post('/shop/devc/brand/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//删除关联系统品牌
exports.updateDevcBrandSysBrandId = function (data, callback) {
    api.post('/shop/devc/brand/sysBrandId/update')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//禁用自有资产品牌
exports.updateDevcBrandDisabled = function (data, callback) {
    api.post('/shop/devc/brand/disabled/update')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//导入自有资产品牌
exports.doImportDevcBrand = function (data, callback) {
    api.post('/shop/devc/brand/import/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//导入自有资产品牌
exports.devcBrandImpModelForExport = function (data, callback) {
    api.post('/shop/devc/brand/imp/model/for/export/url')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//申请自有资产品牌
exports.doApplyDevcBrand = function (data, callback) {
    api.post('/shop/devc/brand/apply/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//申请自有资产品牌
exports.doApplyDevcBrandBatch = function (data, callback) {
    api.post('/shop/devc/brand/batch/apply/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
//查询自有分类的申请列表
exports.getDevcBrandApplyRecList = function (data, callback) {
    api.post('/shop/devc/brand/apply/rec/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ============================ 设备巡检时段 ======================
// 查询设备巡检时段列表
exports.getDevicePatrolPeriodList = function (data, callback) {
    api.post('/shop/devc/patrol/period/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 查询设备巡检时段
exports.getDevicePatrolPeriodById = function (params, callback) {
    api.get('/shop/devc/patrol/period/get/by/id')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 保存设备巡检时段
exports.saveDevicePatrolPeriod = function (data, callback) {
    api.post('/shop/devc/patrol/period/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 批量保存(复制)设备巡检时段
exports.saveDevicePatrolPeriodBatch = function (data, callback) {
    api.post('/shop/devc/patrol/period/batch/save/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 修改设备巡检时段
exports.updateDevicePatrolPeriod = function (data, callback) {
    api.post('/shop/devc/patrol/period/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 删除设备巡检时段
exports.deleteDevicePatrolPeriod = function (data, callback) {
    api.post('/shop/devc/patrol/period/delete/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 删除设备巡检时段
exports.deleteDevicePatrolPeriodByIds = function (data, callback) {
    api.post('/shop/devc/patrol/period/delete/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 禁用设备巡检时段
exports.updateDisabledDevicePatrolPeriod = function (data, callback) {
    api.post('/shop/devc/patrol/period/disabled/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 启用设备巡检时段
exports.doUnDisabledDevicePatrolPeriod = function (data, callback) {
    api.post('/shop/devc/patrol/period/unDisabled/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// ============= 巡检计划 ========================
// 启用设备巡检时段
exports.getDevicePatrolPlanList = function (data, callback) {
    api.post('/shop/devc/patrol/plan/list')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 巡检计划列表
exports.getDevcPatrolPlanPageList = function (data, callback) {
    api.post('/shop/devc/patrol/plan/page/list')
    .data(data)
    .done(callback)
    .go();
};
// 巡检计划新增
exports.saveDevcPatrolPlan = function (data, callback) {
    api.post('/shop/devc/patrol/plan/save')
    .data(data)
    .done(callback)
    .go();
};
exports.updateDevcPatrolPlan = function (data, callback) {
    api.post('/shop/devc/patrol/plan/update')
    .data(data)
    .done(callback)
    .go();
};
// 作废巡检计划
exports.updateDevcPatrolPlanDiscarded = function (data, callback) {
    api.post('/shop/devc/patrol/plan/update/discarded')
    .data(data)
    .done(callback)
    .go();
};
// 取消巡检计划
exports.updateDevcPatrolPlanCancelled = function (data, callback) {
    api.post('/shop/devc/patrol/plan/update/cancelled')
    .data(data)
    .done(callback)
    .go();
};
// 内部巡检计划发布
exports.updateDevcPatrolPlanPublish = function (data, callback) {
    api.post('/shop/devc/patrol/plan/publish/do')
    .data(data)
    .done(callback)
    .go();
};
// 暂停巡检计划
exports.updateDevcPatrolPlanInterrupt = function (data, callback) {
    api.post('/shop/devc/patrol/plan/update/interrupt')
    .data(data)
    .done(callback)
    .go();
};
// 巡检计划删除
exports.deleteDevcPatrolPlan = function (data, callback) {
    api.post('/shop/devc/patrol/plan/delete')
    .data(data)
    .done(callback)
    .go();
};
// 巡检计划终止
exports.doDevcPatrolPlanTermina = function (data, callback) {
    api.post('/shop/devc/patrol/plan/termina/do')
    .data(data)
    .done(callback)
    .go();
};
// 巡检计划查看
exports.getDevcPatrolPlanById = function (data, callback) {
    api.get('/shop/devc/patrol/plan/get/by/id')
    .params(data)
    .done(callback)
    .go();
};

// 巡检计划查看
exports.getDevcPatrolPlanCheckCombCode = function (data, callback) {
    api.get('/shop/devc/patrol/plan/checkCombCode/get')
    .params(data)
    .done(callback)
    .go();
};
// 巡检计划操作记录
exports.getDevcPatrolPlanRecList = function (data, callback) {
    api.post('/shop/devc/patrol/plan/rec/list/do')
    .data(data)
    .done(callback)
    .go();
};
// ================== 资产定义项 =====================

// 根据商品分类获取资产分类
exports.getDevcCatByGoodsCatId = function (params, callback) {
    api.get('/shop/devc/cat/get/by/goods/id')
    .params(params)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取保养计划列表ids
exports.getDeviceMaintPlanListByIds = function (data, callback) {
    api.post('/shop/devc/maint/plan/list/get/by/ids')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取布放区环境记录列表
exports.getLayoutAreaEnvRecListByFilter = function (data, callback) {
    api.post('/shop/devc/layout/area/rec/list/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// 资产分类-关联数据
exports.getDevcCatRel = function (data, callback) {
    api.post('/shop/devc/devc/cat/rel/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 资产分类-关联数据同步
exports.doSyncDevcCatRel = function (data, callback) {
    api.post('/shop/devc/devc/cat/rel/sync/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};

// ===================

exports.getDevcCustInfo = function (data, callback) {// 门店设备服务号详情
    api.get('/shop/devc/cust/info/get')
    .params(data)
    .done(callback)
    .go();
};
exports.updateDevcCustInfo = function (data, callback) {
    api.post('/shop/devc/cust/info/update/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.validateOuterUnsettledImpModel = function (data, callback) {
    api.post('/shop/devc/outerUnsettled/imp/model/validate')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doDeviceOuterUnsettledImpModelImport = function (data, callback) {
    api.post('/shop/devc/outerUnsettled/imp/model/import/do')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doDeviceOuterUnsettledSingle = function (data, callback) {
    api.post('/shop/devc/device/outerUnsettle/single/update')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
exports.doDeviceOuterUnsettledDurable = function (data, callback) {
    api.post('/shop/devc/device/outerUnsettle/durable/update')
    .data(data)
    .done(callback)
    .fail(callback)
    .go();
};
// 获取最近审核人信息
exports.getLastAuditInfo = function (data, callback) {
    api.post('/shop/devc/last/audit/info/get')
    .data(data)
    .done(callback)
    .fail(callback)
    .go()
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/shopDevc.js
// module id = 12
// module chunks = 0